import { Link, useNavigate } from "@tanstack/react-router";
import { ShoppingCart, ArrowLeft, User, LogOut } from "lucide-react";
import { useCart } from "@/lib/cart";
import { useAuth } from "@/lib/auth";
import { useStoreSettings } from "@/lib/settings.functions";
import { SiteMenu } from "@/components/site-menu";

export function SiteHeader() {
  const count = useCart((s) => s.itemCount());
  const openDrawer = useCart((s) => s.openDrawer);
  const user = useAuth((s) => s.user);
  const signOut = useAuth((s) => s.signOut);
  const navigate = useNavigate();
  const settings = useStoreSettings();

  return (
    <header className="sticky top-0 z-40 bg-eg-dark text-white shadow-lg">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4">
        <div className="flex items-center gap-2">
          <SiteMenu />
          <Link to="/" className="flex h-9 w-36 items-center">
            {settings.logo_url ? (
              <img
                src={settings.logo_url}
                alt={settings.nome_fantasia}
                width={144}
                height={36}
                className="h-full w-full object-contain object-left"
              />
            ) : (
              <span className="flex items-baseline gap-1 font-display text-2xl font-extrabold text-eg-gold">
                EG <span className="text-white text-xl font-semibold">Elétrica</span>
              </span>
            )}
          </Link>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          <a
            href={settings.institutional_url}
            className="hidden sm:inline-flex items-center gap-1 text-sm text-white/90 hover:text-eg-gold transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar ao site
          </a>
          {user ? (
            <button
              type="button"
              onClick={async () => {
                await signOut();
                navigate({ to: "/" });
              }}
              className="hidden sm:inline-flex items-center gap-1 text-sm text-white/90 hover:text-eg-gold transition-colors"
            >
              <LogOut className="h-4 w-4" />
              Sair
            </button>
          ) : (
            <Link
              to="/login"
              className="hidden sm:inline-flex items-center gap-1 text-sm text-white/90 hover:text-eg-gold transition-colors"
            >
              <User className="h-4 w-4" />
              Entrar
            </Link>
          )}
          <button
            type="button"
            onClick={openDrawer}
            aria-label="Abrir carrinho"
            className="relative rounded-full p-2 hover:bg-white/10 transition-colors"
          >
            <ShoppingCart className="h-6 w-6" />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-eg-gold px-1 text-xs font-bold text-eg-dark">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
